module.exports = __webpack_public_path__ + "images/般蓝pr长图06-2_02.jpg?v=ae10295b";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图06-2_02.jpg
 ** module id = 174
 ** module chunks = 1 2
 **/